import { dbFirestore } from "firestore";
import useSWRImmutable from "swr/immutable";

import type { Event } from "@spwn/types/firebase/firestore";
import type { Place } from "firestore/types";

export const useEventPlace = (event: Event | undefined): Place | undefined => {
  const placeId = event?.placeInfo?.placeRefs?.[0]?.id;
  const { data } = useSWRImmutable<Place | undefined>(
    placeId ? ["place", placeId] : null,
    async ([, id]: [string, string]) => {
      try {
        const snap = await dbFirestore.places().doc(id).get();
        return snap.data() ?? undefined;
      } catch (e) {
        console.error("failed to fetch place", e);
        return undefined;
      }
    }
  );
  return data;
};
